import { useContext, useEffect } from 'react';

import { useRouter, useStoreData } from '../';
import { ClientError } from '../../api';
import { ApiContext, CoreContext } from '../../providers';
import { addUserData, setError } from '../../state';
import { isEmptyObject } from '../../utils';

export const useProfileData = () => {
    const { pathname } = useRouter();
    const { Upscore } = useContext(ApiContext);
    const { store } = useContext(CoreContext);
    const { profileData } = useStoreData().user;

    useEffect(() => {
        /**
         * Skip data fetching if data is present in the store
         */
        if (profileData && !isEmptyObject(profileData)) return;

        (async () => {
            try {
                const profileData = await Upscore.getUserProfile();
                store.dispatch(addUserData('profileData', profileData));
            } catch (error) {
                store.dispatch(setError('general'));
                throw new ClientError(error.message, {
                    category: 'Upscore API',
                    type: 'general',
                    error,
                });
            }
        })();
    }, [pathname, profileData]);

    return { profileData };
};
